import { Document } from '@/DTOS/User/Document';
import { Button, Modal, Select } from 'antd';
import { FC, useState } from 'react';

const { Option } = Select;

interface UserFileModalProps {
  id: string;
  modalFileVisible: boolean;
  handleDocs: (doc: Document) => void;
  handleFileCancel: () => void;
}

const UserFileModal: FC<UserFileModalProps> = ({ id, modalFileVisible, handleDocs, handleFileCancel }) => {
  const [selectedTemplate, setSelectedTemplate] = useState<string | null>(null);

  const handleSelectChange = (value: string) => {
    setSelectedTemplate(value);
  };

  return (
    <Modal title={'Descarca Fisier'} open={modalFileVisible} onCancel={handleFileCancel} width={700} footer={null}>
      <Select
        style={{ width: '100%', marginBottom: '20px' }}
        placeholder='Selecteaza un template'
        onChange={handleSelectChange}
      >
        <Option value='Helion.Template1'>Helion.Template1</Option>
        <Option value='Helion.Template2'>Helion.Template2</Option>
      </Select>

      <Button type='primary' onClick={() => handleDocs({ id: id, name: selectedTemplate! })}>
        Descarca
      </Button>
    </Modal>
  );
};

export default UserFileModal;
